<script setup lang="ts">
const { image } = defineProps<{
  title: string
  text: string
  button?: StoryBlokButton[]
  image: StoryBlokImage
}>()

const backgroundImage = `url(${image.filename.replace('https://a.storyblok.com', 'https://img2.storyblok.com/1940x395')})`
</script>

<template>
  <div class="background-image bg-opacity-25">
    <div class="content-container min-h-325px relative flex items-center py-5 md:min-h-360px">
      <div class="z-2 flex flex-col justify-center gap-5 items-start md:items-center md:text-center">
        <h2>{{ title }}</h2>
        <hr class="border-primary border-t-5 w-14">
        <p class="text-large">
          {{ text }}
        </p>
        <StoryblokButton v-if="button?.length" class="w-full" v-bind="button[0]" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.background-image {
  background-image: v-bind("backgroundImage");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}
</style>
